import { paths } from '../../common/constants/pathVariables.js';
import { basicDetailsMsg, billingAccountAndUserMsg, t } from '../../common/i18n/index.js';
import { SubscriptionType } from '../../generated/api/subscriptionType.js';
import { getSubscriptionUrl } from './MobileSubscriptionLayout.js';
import type { Subscription } from '../../generated/api/subscription.js';
import type { LocalNaviItem } from '../LocalNavi/index.js';

// PBX services (Vakio, Ring) are still rendered with the accordion page (SubscriptionService)
export const isPbxServiceSubscription = (subscription: Subscription) =>
  subscription.subscriptionType === SubscriptionType.MOBILE_PBX ||
  subscription.subscriptionType === SubscriptionType.MOBILE_PBX_LITE;

export const getServiceNavigationItems = (subscription: Subscription, mdmId: string): LocalNaviItem[] => [
  {
    children: t.C9M1(basicDetailsMsg),
    to: getSubscriptionUrl(paths.PS_SERVICE, subscription, mdmId),
  },
  {
    children: t.CZ63(billingAccountAndUserMsg),
    to: getSubscriptionUrl(paths.PS_SERVICE_BA_CONTRACT_PARTY, subscription, mdmId),
  },
];
